module.exports = __webpack_public_path__ + "static/media/toggle-on.9b4f7bbc.svg";